import TrackingService, { ActionName } from './TrackingService.ts';
import type { PointsInfoBannerType } from '../../domain/points-info-banner/PointsInfoBannerType.ts';
import { Topic } from './Topic.ts';

export const trackPointsInfoClick = (trackingService: TrackingService, bannerType: PointsInfoBannerType) => {
	trackingService.sendEvent(Topic.SubmitEvent, {
			up_PointsBanner: [ActionName.OPEN],
			up_BannerType: [bannerType]
		}
	);
};

export const trackPointsInfoSeen = (trackingService: TrackingService, bannerType: PointsInfoBannerType) => {
	trackingService.sendEvent(Topic.SubmitEvent, {
			up_PointsBanner: [ActionName.SEEN],
			up_BannerType: [bannerType]
		}
	);
};

export const trackPointsInfoView = (trackingService: TrackingService, bannerType: PointsInfoBannerType) => {
	trackingService.sendEvent(Topic.MergeEvent, {
			up_PointsBanner: [ActionName.VIEW],
			up_BannerType: [bannerType]
		}
	);
};
